import { IShippingMethod } from "@app/checkout/checkout.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const shippingMethodAdapter: EntityAdapter<IShippingMethod> = createEntityAdapter<IShippingMethod>({
	selectId: shippingMethod => shippingMethod.id
});